/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonIdAttachmentsAttachmentid202,
  DeleteApiV1PersonIdAttachmentsAttachmentid401,
  DeleteApiV1PersonIdAttachmentsAttachmentid404,
  DeleteApiV1PersonIdAttachmentsAttachmentid500,
  DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
  DeleteApiV1PersonIdAttachmentsAttachmentidPathParams,
} from "../../types/personDocumentsController/DeleteApiV1PersonIdAttachmentsAttachmentid.ts";

export const deleteApiV1PersonIdAttachmentsAttachmentidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    attachmentId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1PersonIdAttachmentsAttachmentid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonIdAttachmentsAttachmentid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonIdAttachmentsAttachmentid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonIdAttachmentsAttachmentid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentid500>;

export const deleteApiV1PersonIdAttachmentsAttachmentidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1PersonIdAttachmentsAttachmentid202Schema,
  ) as unknown as ToZod<DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse>;
